import { Component, OnInit, Input, ViewChild, ElementRef, TemplateRef } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { SessionService } from '../../services/session.service';
import { Producto } from '../../models/producto';
import { ProductoService } from '../../services/producto.service';
import { Subcategoria } from '../../models/subcategoria';
import { SubcategoriaService } from '../../services/subcategoria.service';
import { Unidad } from '../../models/unidad';
import { UnidadService } from '../../services/unidad.service';
import { Validation } from '../../config/validation';
import { SweetMessage } from '../../config/sweet-message';
import { Categoria } from '../../models/categoria';
import { CategoriaService } from '../../services/categoria.service';
import { Marca } from '../../models/marca';
import { MarcaService } from '../../services/marca.service';
import { ModeloService } from '../../services/modelo.service';
import { Modelo } from '../../models/modelo';
import { ConfigService } from '../../config/config-service';
import { CampoAdicional } from '../../models/campo-adicional';
import { CampoAdicionalService } from '../../services/campo-adicional.service';
import { BsModalService, BsModalRef } from 'ngx-bootstrap';
import { environment } from '../../../environments/environment';
import { TipoCuentaService } from '../../services/tipo-cuenta.service';
import { TipoCuenta } from '../../models/tipo-cuenta';
import { CuentaContableService } from '../../services/cuenta-contable.service';
import { Pagination } from '../../models/pagination';
import { CuentaContableModalComponent } from '../../components/modals/cuenta-contable-modal/cuenta-contable-modal.component';
import { ImpuestoPorcentajeService } from '../../services/impuesto-porcentaje.service';
import { ReporteModalComponent } from '../../components/modals/reporte-modal/reporte-modal.component';
import * as moment from 'moment';
import { IceModalComponent } from '../../components/modals/ice-modal/ice-modal.component';
import { SalaPreparacionService } from '../../services/sala-preparacion.service';
import { SalaPreparacion } from '../../models/sala-preparacion';
import { ParametroContabilidadService } from '../../services/parametro-contabilidad.service';
import { ParametroContabilidad } from '../../models/parametro-contabilidad';
import { CuentaContable } from '../../models/cuenta-contable';
import { TipoProductoService } from '../../services/tipo-producto.service';
import { TipoProducto } from '../../models/tipo-producto';

declare var $: any;

@Component({
	selector: 'app-producto-frm-add',
	templateUrl: './producto-frm-add.component.html',
	styleUrls: ['./producto-frm-add.component.css'],
	providers: [
		ProductoService,
		SubcategoriaService,
		CategoriaService,
		UnidadService,
		SessionService,
		MarcaService,
		ModeloService,
		CampoAdicionalService,
		TipoCuentaService,
		CuentaContableService,
		ImpuestoPorcentajeService,
		SalaPreparacionService,
		ParametroContabilidadService,
		TipoProductoService,
	]
})
export class ProductoFrmAddComponent implements OnInit {
	@Input() btnCalelHidden: boolean = false;
	public producto: Producto;
	public cta_ingreso: string;
	public cta_inventario_id: string;
	public cta_ingreso_id: string;
	public cta_inventario: string;
	public categorias: Array<Categoria>;
	public subcategorias: Array<Subcategoria> = [];
	public unidades: Array<Unidad> = [];
	public msg: SweetMessage;
	myForm: FormGroup;
	public vl: Validation;
	public loading = false;
	public loadingCuenta: boolean;
	public marcas: Array<Marca>;
	public modelos: Array<Modelo>;
	public image: File;
	public ruta_imagen: String;
	public config: ConfigService;
	public imgURL: any;
	@ViewChild('inputFile') inputFile: ElementRef;
	public camposAdicionales: Array<CampoAdicional>;
	public loadingNuevoCampo: boolean;
	public bsModalRef: BsModalRef;
	public bsModalRefCuentaIngreso: BsModalRef;
	public bsModalRefCuentaInventario: BsModalRef;
	public bsModalRefEdit: BsModalRef;
	public campoAdicional: CampoAdicional;
	public campoAdicionalEdit: CampoAdicional;
	public loadingEditarCampo: boolean;
	public perfil_id: String;
	public Mod_Ecommerce: string;
	public Mod_Restaurante: string;
	public uploadfile_api: String;
	public tiposCuenta: Array<TipoCuenta>;
	public tipoCuenta: TipoCuenta;
	public cuentas: any;
	public pagination: Pagination;
	public busqueda: string;
	public selectedRow: Number;
	// public es_servicio: Number;
	public impuesto_porcentaje_iva: Array<any>;
	public impuesto_porcentaje_ice: Array<any>;
	public format_decimal: string;
	public fecha_emision;
	public producto_codigo: string;
	public producto_nombre: string;
	public Mod_Contabilidad:string;
	public impuesto_porcentaje:any;
	public sala_preparacion_id: String;
	public salasPreparacion: Array<SalaPreparacion>;
	public change_tabs: boolean;
	public is_graba_iva :boolean;
	public parametrosContabilidad: Array<ParametroContabilidad>;
	public es_vendido: boolean;
	public es_comprado: boolean;
	public tiposProductos: Array<TipoProducto>;
	public tipo_producto_id: string;
	constructor(
		private productoService: ProductoService,
		private subcategoriaService: SubcategoriaService,
		private unidadService: UnidadService,
		private ss: SessionService,
		private fb: FormBuilder,
		private categoriaService: CategoriaService,
		private marcaService: MarcaService,
		private modeloService: ModeloService,
		private campoAdicionalService: CampoAdicionalService,
		private modalService: BsModalService,
		private tipoCuentaService: TipoCuentaService,
		private cuentaContableService: CuentaContableService,
		private impuestoPorcentajeService: ImpuestoPorcentajeService,
		private salaPreparacionService: SalaPreparacionService,
		private parametroContabilidadService: ParametroContabilidadService,
		private tipoProductoService: TipoProductoService,
	) {
		this.categorias = [];
		this.marcas = [];
		this.modelos = [];
		this.ruta_imagen = "";
		this.config = new ConfigService();
		this.camposAdicionales = [];
		this.loadingNuevoCampo = false;
		this.campoAdicional = new CampoAdicional();
		this.campoAdicionalEdit = new CampoAdicional();
		this.perfil_id = this.ss.getData('perfil_id');
		this.Mod_Ecommerce = this.ss.getData("mod_ecommerce");
		this.Mod_Restaurante = this.ss.getData("mod_restaurante");
		this.uploadfile_api = environment.uploadfile_api;
		this.loadingCuenta = false;
		this.tiposCuenta = [];
		this.tipoCuenta = new TipoCuenta();
		this.cuentas = [];
		this.pagination = new Pagination();
		this.busqueda = "";
		// this.es_servicio = 0;
		this.impuesto_porcentaje_iva = [];
		this.impuesto_porcentaje_ice = [];
		this.format_decimal = "0,0";
		this.cta_ingreso = "";
		this.cta_inventario = "";
		this.cta_ingreso_id = "";
		this.cta_inventario_id = "";
		this.fecha_emision = moment(this.fecha_emision);
		this.producto_codigo = "";
		this.producto_nombre = "";
		this.Mod_Contabilidad = this.ss.getData("mod_contabilidad");
		this.impuesto_porcentaje = {};
		this.impuesto_porcentaje.descripcion = "";
		this.sala_preparacion_id = "";
		this.salasPreparacion = [];
		this.change_tabs = false;
		this.is_graba_iva = false;
		this.parametrosContabilidad = [];
		this.es_vendido = true;
		this.es_comprado = true;
		this.tiposProductos = [];
		
	}

	ngOnInit() {
		this.setSrcImage();
		//Inicializar Formulario
		this.onForm();
		//Inicializacion de Objectos
		this.msg = new SweetMessage();
		//Inicializacion de Objecto de validacion
		this.vl = new Validation();
		//Inicializacion de objecto Producto
		this.producto = new Producto();
		// this.producto.impuesto_iva_id = '128';
		//Obtener informacion de productos y unidades
		this.getCategorias();
		this.getUnidades();
		this.getMarcas();
		this.getCamposAdicionales("?status=A");
		let p1 = this.getImpuestoPorcentaje(2);
		// let p2 = this.getImpuestoPorcentaje(4);
		let p2 = this.getCuentaContable(1010301);
		let p3 = this.getCuentaContable(40101);
		let p5 = this.getSalaPreparacion();
		let p7 = this.getTiposProducto();
		let p6 = null;
		if(this.Mod_Contabilidad) p6 = this.getParametroContabilidadProductos();
		Promise.all([p1,p2,p3,p5,p6,p7]).then(
			res => this.loading = false,
			err => this.loading = false
		);
		// this.es_servicio = 0;
		this.tipo_producto_id = '1';
		this.myForm.controls['es_vendido'].setValue(this.es_vendido);
		this.myForm.controls['es_comprado'].setValue(this.es_comprado);	
	}

	getParametroContabilidadProductos(){
        return new Promise((resolve, reject) => {
            let qs = "?status=A&tipo=P&notin[id]=39,40&embed=cuentacontable";
            if( this.Mod_Contabilidad ) {
                this.parametroContabilidadService.getAll(qs).subscribe(
                    res => {
                       this.parametrosContabilidad = res.data;
                        resolve(true);
                    },
                    err => {
                        reject(err);
                    }
                );
            }
            
        });
	}

	changeTabs(event) {

	}

	setSrcImage() {
		this.ruta_imagen = this.uploadfile_api + "/image/nofoto.png?tk=" + this.ss.getData('api-token') + "&dbname=" + this.ss.getData('dbname');
	}

	getSalaPreparacion(){
		return new Promise((resolve, reject) => {
			this.salaPreparacionService.getAll().subscribe(
				res => {
					this.salasPreparacion = res.data;
					resolve(true);
				},
				err => {
					this.salasPreparacion = [];
					reject();
				}
			);
		});
	}

	getImpuestoPorcentaje(impuesto_id){
		this.loading = true;
		let qs = "?impuesto_id=" + impuesto_id + "&is_tarifa=1&is_vigente=1";
		return new Promise((resolve, reject) => {
			this.impuestoPorcentajeService.getAll(qs).subscribe(
				res => {
					this.impuesto_porcentaje_iva = res.data;

					this.loading = false;
					// if( res.data[0].impuesto_id == 2){
					// }else{
					// 	this.impuesto_porcentaje_ice = res.data;
					// }

					resolve(true);
				}, err => {
					this.impuesto_porcentaje_iva = [];
					// this.impuesto_porcentaje_ice = [];
					reject();
				}
			);
		});
	}


	openModalIce() {

		const initialState = { impuesto_porcentaje_ice: this.impuesto_porcentaje_ice };
		this.bsModalRef = this.modalService.show(IceModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));

		this.bsModalRef.content.sendImpuestoIce.take(1).subscribe(value => {
			this.impuesto_porcentaje = value;
		});

	}

	getTiposProducto(){
        return new Promise((resolve, reject)=>{
          

            this.tipoProductoService.getAll().subscribe(
                res => {
                    this.tiposProductos = res.data;
                    resolve(true);
                },
                err => {
                    this.tiposProductos = [];
                    reject(err);
                }
            );
        });
    }

	getCamposAdicionales(qs = "") {
		this.loadingNuevoCampo = true;
		this.loading = true;
		this.campoAdicionalService.getAll(qs).subscribe(
			res => {
				this.camposAdicionales = res.data;
				this.loadingNuevoCampo = false;
				this.loading = false;
			},
			err => {
				this.camposAdicionales = [];
				this.loadingNuevoCampo = false;
				this.loading = false;
			}
		);
	}

	/*camposActivos(){
		return this.camposAdicionales.filter(x=>x.status=='A').length>0;
	}*/

	onSubmit() {
		if (this.image) {
			this.setValueEntity();
			// this.loading = true;

			const formData = new FormData();
			formData.append('image', this.image, this.image.name);

			this.productoService.uploadImage(formData).subscribe(
				res => {
					this.producto.imagen = res.filename;
					this.productoService.save(this.producto).subscribe(
						res => {
							// this.loading = false;
							this.producto_codigo = res.id;
							this.producto_nombre = res.nombre;
							this.msg.showMessage('success-message', res.message);
							this.producto = new Producto();
							this.image = undefined;
							
							this.impuesto_porcentaje.descripcion = "";
							this.onForm();
							this.es_vendido = true;
							this.es_comprado = true;
							this.myForm.controls['es_vendido'].setValue(this.es_vendido);
							this.myForm.controls['es_comprado'].setValue(this.es_comprado);	
							this.getParametroContabilidadProductos().then(
								res => this.loading = false,
								err => this.loading = false,
							);
						},
						err => {
							this.loading = false;
							this.msg.showMessage('error-message', err);
						}
					);
				},
				err => {
					this.loading = false;
					this.es_vendido = true;
					this.es_comprado = true;
					this.myForm.controls['es_vendido'].setValue(this.es_vendido);
					this.myForm.controls['es_comprado'].setValue(this.es_comprado);
					this.msg.showMessage('error-message', err);
				}
			);
		} else {
			this.setValueEntity();
			this.loading = true;
			this.productoService.save(this.producto).subscribe(
				res => {
					this.loading = false;
					this.msg.showMessage('success-message', res.message);
					this.producto = new Producto();
					
					this.impuesto_porcentaje.descripcion = "";
					this.getParametroContabilidadProductos().then(
						res => this.loading = false,
						err => this.loading = false,
					);
					this.productoService.getAll().subscribe(res => {
						let resp = [];
						resp = res.data;
						let ultimo = resp[resp.length - 1];
						// this.es_servicio = ultimo.es_servicio;
						this.tipo_producto_id = ultimo.tipo_producto_id;
						this.onForm();
						this.es_vendido = true;
					this.es_comprado = true;
					this.myForm.controls['es_vendido'].setValue(this.es_vendido);
					this.myForm.controls['es_comprado'].setValue(this.es_comprado);
						// this.myForm.controls['tipo'].setValue(this.es_servicio);
						this.myForm.controls['tipo_producto_id'].setValue(this.tipo_producto_id);
						// this.myForm.setValue({
						// 	tipo: this.es_servicio,
						// });
					});

				},
				err => {
					this.loading = false;
					this.es_vendido = true;
					this.es_comprado = true;
					this.myForm.controls['es_vendido'].setValue(this.es_vendido);
					this.myForm.controls['es_comprado'].setValue(this.es_comprado);
					this.msg.showMessage('error-message', err);
				}
			);
		}
	}

	limpiarCuenta(parametroCuenta){
		// parametroCuenta.cuentacontable = new CuentaContable();
		parametroCuenta.status = "I";
		parametroCuenta.cuenta_contable_id = '';
		
		
		parametroCuenta.cuentacontable = new CuentaContable();
	  }

	getCategorias() {
		this.loading = true;
		this.categoriaService.getAll().subscribe(
			res => {
				this.loading = false;
				this.categorias = res.data;
			},
			err => {
				this.loading = false;
				this.categorias = [];
			}
		);
	}

	getSubcategorias() {
		let categoria_id = this.myForm.controls['categoria_id'].value;
		this.loading = true;
		this.subcategoriaService.getAll('?categoria_id=' + categoria_id).subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.subcategorias = null;
				} else {
					this.subcategorias = res.data;
				}
			},
			err => {
				this.loading = false;
				this.subcategorias = [];
			}
		);
	}

	getMarcas() {
		this.loading = true;
		this.marcaService.getAll().subscribe(
			res => {
				this.loading = false;
				this.marcas = res.data;
			},
			err => {
				this.loading = false;
				this.marcas = [];
			}
		);
	}

	onChangeMarca() {
		let marca_id = this.myForm.controls['marca_id'].value;
		this.getModelos(marca_id);
	}

	getModelos(marca_id) {
		this.loading = true;
		this.modeloService.getAll("?marca_id=" + marca_id).subscribe(
			res => {
				this.loading = false;
				this.modelos = res.data;
			},
			err => {
				this.loading = false;
				this.modelos = [];
			}
		);
	}

	getUnidades() {
		this.loading = true;
		this.unidadService.getAll().subscribe(
			res => {
				this.loading = false;
				if (!res.data.length) {
					this.unidades = null;
				} else {
					this.unidades = res.data;
				}
			},
			err => {
				this.loading = false;
				this.unidades = [];
			}
		);
	}

	onChangeCategoria() {
		this.getSubcategorias();
	}

	onForm() {
		this.myForm = this.fb.group({
			codigo: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9\s]*/),Validators.maxLength(20)]],
			codigo_externo: ['',Validators.maxLength(20)],
			nombre: ['', [Validators.required, Validators.pattern(/[A-Za-z0-9ñÑáéíóúÁÉÍÓÚ\s]*/),Validators.maxLength(200)]],
			descripcion: "",
			ubicacion: "",
			tipo_producto_id: ['1', [Validators.required]],
			iva: ['', [Validators.required]],
			manejar_por: [null],
			ice: [{ value: '', disabled: true }, null],
			stock_minimo: "",
			stock_maximo: "",
			cta_ingreso: [{ value: '', disabled: true }, null],
			cta_inventario: [{ value: '', disabled: true }, null],
			categoria_id: ['', [Validators.required]],
			subcategoria_id: [null],
			unidad_medida_id: ['', [Validators.required]],
			marca_id: [null],
			modelo_id: [null],
			incluye_iva: [''],
			graba_iva: [''],
			// es_servicio: [''],
			es_vendido: [''],
			es_comprado: [''],
			ver_ecommerce: [''],
			sala_preparacion_id: [''],
			precio: [, [Validators.required, Validators.pattern(/^[0-9]+(\.[0-9]{1,4})?$/)]],
			costo: [, [Validators.pattern(/^[0-9]+(\.[0-9]{1,2})?$/)]]
		});
		this.validarUnidadMedida();
	}

	validarUnidadMedida() {
		this.myForm.get('tipo_producto_id').valueChanges
			.subscribe(value => {
				if (value == 1) {
					this.myForm.get('unidad_medida_id').setValidators(Validators.required)
				} else {
					this.myForm.get('unidad_medida_id').clearValidators();
				}
				this.myForm.get('unidad_medida_id').updateValueAndValidity();
			}
			);
	}

	setValueForm() {
		this.myForm.setValue({
			codigo: this.producto.codigo,
			codigo_externo: this.producto.codigo_externo,
			nombre: this.producto.nombre,
			descripcion: this.producto.descripcion,
			ubicacion: this.producto.ubicacion,
			categoria_id: this.producto.categoria_id,
			subcategoria_id: this.producto.subcategoria_id,
			unidad_medida_id: this.producto.unidad_medida_id,
			marca_id: this.producto.marca_id,
			modelo_id: this.producto.modelo_id,
			incluye_iva: this.producto.incluye_iva,
			graba_iva: this.producto.graba_iva,
			iva: this.producto.impuesto_iva_id,
			ice: this.producto.impuesto_ice_id,
			manejar_por: this.producto.if_uso_lote,
			stock_maximo: this.producto.stock_maximo,
			stock_minimo: this.producto.stock_minimo,
			// es_servicio: this.producto.es_servicio,
			tipo_producto_id: this.producto.tipo_producto_id,
			es_vendido: this.producto.es_vendido,
			es_comprado: this.producto.es_comprado,
			ver_ecommerce: this.producto.ver_ecommerce,
			sala_preparacion_id: this.producto.sala_preparacion_id,
			precio: this.producto.precio,
			costo: this.producto.costo,
		});
	}

	

	setValueEntity() {
		this.producto.codigo = this.myForm.controls['codigo'].value;
		this.producto.codigo_externo = this.myForm.controls['codigo_externo'].value;
		this.producto.nombre = this.myForm.controls['nombre'].value;
		this.producto.descripcion = this.myForm.controls['descripcion'].value;
		this.producto.ubicacion = this.myForm.controls['ubicacion'].value;
		this.producto.categoria_id = this.myForm.controls['categoria_id'].value;
		this.producto.subcategoria_id = this.myForm.controls['subcategoria_id'].value;
		this.producto.unidad_medida_id = this.myForm.controls['unidad_medida_id'].value ? this.myForm.controls['unidad_medida_id'].value : null;
		this.producto.marca_id = this.myForm.controls['marca_id'].value;
		this.producto.modelo_id = this.myForm.controls['modelo_id'].value;
		this.producto.incluye_iva = this.myForm.controls['incluye_iva'].value;
		this.producto.impuesto_ice_id = this.impuesto_porcentaje.id ? this.impuesto_porcentaje.id : '0';
		this.producto.impuesto_iva_id = this.myForm.controls['iva'].value;
		let resp = this.impuesto_porcentaje_iva.filter(i=>i.id == this.producto.impuesto_iva_id);
		let porcentaje = parseInt(resp[0].porcentaje);
		porcentaje > 0?this.producto.graba_iva = true:this.producto.graba_iva = false;
		// this.producto.es_servicio = this.myForm.controls['tipo'].value;
		this.producto.tipo_producto_id = this.myForm.controls['tipo_producto_id'].value;
		this.producto.es_vendido = this.myForm.controls['es_vendido'].value;
		this.producto.es_comprado = this.myForm.controls['es_comprado'].value;
		this.producto.if_uso_lote = this.myForm.controls['manejar_por'].value!=''?this.myForm.controls['manejar_por'].value:null;
		this.producto.stock_maximo = this.myForm.controls['stock_maximo'].value ? this.myForm.controls['stock_maximo'].value : null;
		this.producto.stock_minimo = this.myForm.controls['stock_minimo'].value ? this.myForm.controls['stock_maximo'].value : null;
		// this.producto.cuenta_ingreso_id = this.myForm.controls['cta_ingreso'].value && this.Mod_Contabilidad ? this.myForm.controls['cta_ingreso'].value : '0' ;
		// this.producto.cuenta_inventario_id = this.myForm.controls['cta_inventario'].value && this.Mod_Contabilidad ? this.myForm.controls['cta_inventario'].value : '0';
		this.producto.ver_ecommerce = this.myForm.controls['ver_ecommerce'].value;
		this.producto.sala_preparacion_id = this.myForm.controls['sala_preparacion_id'].value;
		this.producto.precio = this.myForm.controls['precio'].value;
		this.producto.costo = this.myForm.controls['costo'].value;
		this.producto.usuario_id = this.ss.getData('usuario_id');
		this.producto.empresa_id = this.ss.getData('empresa_id');
		this.parametrosContabilidad.forEach(parametroCuenta =>{
			if(parametroCuenta.nombre.trim().toLowerCase() == 'Ingresos'.trim().toLowerCase()){
				
				this.producto.cuenta_ingreso_id = parametroCuenta.cuenta_contable_id;
			}
			if(parametroCuenta.nombre.trim().toLowerCase() == 'Costos/Gastos'.trim().toLowerCase()){
				this.producto.cuenta_costo_gasto_id = parametroCuenta.cuenta_contable_id;
			}
			if(parametroCuenta.nombre.trim().toLowerCase() == 'Inventario'.trim().toLowerCase()){
				this.producto.cuenta_inventario_id = parametroCuenta.cuenta_contable_id;

			}
		});
	}

	


	validErrorForm(campo) {
		return this.vl.validErrorForm(campo, this.myForm);
	}

	validTypeMsgForm(nombre, campo) {
		return this.vl.validTypeMsgForm(nombre, campo, this.myForm);
	}

	uploadImage(event) {
		this.image = event.target.files[0];

		var mimeType = this.image.type;

		if (mimeType.match(/image\/*/) == null) {
			this.image = undefined;
			this.imgURL = undefined;
			this.inputFile.nativeElement.value = '';
			this.msg.showMessage('error-message', 'El archivo seleccionado no es una imagen');
			return;
		}

		var reader = new FileReader();
		reader.readAsDataURL(this.image);
		reader.onload = (_event) => {
			this.imgURL = reader.result;
		}
	}

	openModalNuevoCampo(template: TemplateRef<any>) {
		this.getCamposAdicionales();

		this.bsModalRef = this.modalService.show(template, Object.assign({ backdrop: 'static' }));
	}

	openModalEditCampo(template: TemplateRef<any>, campo) {
		this.campoAdicionalEdit = campo;
		const initialState = {};
		this.bsModalRefEdit = this.modalService.show(template, Object.assign({  backdrop: 'static',class: 'modal-sm', initialState }));
	}

	isValidCampoAdicional() {
		if (this.campoAdicional.codigo.trim().length == 0) {
			return false;
		}
		/*if( this.campoAdicional.descripcion.trim().length == 0 ){
			return false;
		}*/
		return true;
	}

	saveCampoAdicional() {
		this.loadingNuevoCampo = true;

		this.campoAdicional.usuario_id = this.ss.getData('usuario_id');
		this.campoAdicional.empresa_id = this.ss.getData('empresa_id');

		this.campoAdicional.codigo.trim();
		this.campoAdicionalService.save(this.campoAdicional).subscribe(
			res => {
				this.msg.showMessage('success-message', res.message);
				this.campoAdicional = new CampoAdicional();
				this.loadingNuevoCampo = false;

				this.getCamposAdicionales();
			},
			err => {
				this.msg.showMessage('error-message', err);
				this.loadingNuevoCampo = false;
			}
		);
	}

	editarCampoAdicional() {
		this.loadingEditarCampo = true;
		this.campoAdicionalService.update(this.campoAdicionalEdit).subscribe(
			res => {
				this.msg.showMessage('success-message', res.message);
				this.loadingEditarCampo = false;
				this.bsModalRefEdit.hide();
				this.getCamposAdicionales();
			},
			err => {
				this.msg.showMessage('error-message', err);
				this.loadingEditarCampo = false;
			}
		);
	}

	removeCampoAdicional(campo, i) {
		this.msg.showMessage('delete-confirm-message').then(
			res => {
				if (res == "ok") {
					this.loadingNuevoCampo = true;
					this.campoAdicionalService.delete(campo.id).subscribe(
						res => {
							this.msg.showMessage('success-message', res.message);
							this.loadingNuevoCampo = false;
							//this.camposAdicionales.splice(i,1);
							//this.getCamposAdicionales();
							campo.status = 'I';
						},
						err => {
							this.msg.showMessage('error-message', err);
							this.loadingNuevoCampo = false;
						}
					);
				}
			}
		);
	}

	reactivarCampo(campo) {
		this.loadingNuevoCampo = true;
		this.campoAdicionalService.reactivar(campo).subscribe(
			res => {
				campo.status = "A";
				this.msg.showMessage('success-message', res.message);
				this.loadingNuevoCampo = false;
			},
			err => {
				this.msg.showMessage('error-message', err);
				this.loadingNuevoCampo = false;
			}
		);
	}

	getEstadoCampo(campo) {
		return campo.status == 'A' ? "Activo" : "Inactivo";
	}

	closeModalCampoNuevo() {
		this.bsModalRef.hide();
		this.getCamposAdicionales("?status=A");
	}

	generarCodigoAleatorio() {
		this.myForm.controls['codigo'].setValue(Math.floor(Math.random() * (9999999999 - 1000000000)) + 1000000000);

	}

	generarCodigoAleatorioExterno() {
		this.myForm.controls['codigo_externo'].setValue(Math.floor(Math.random() * (9999999999 - 1000000000)) + 1000000000);

	}

	activeIncluyeIva(incluyeIva) {
		// this.myForm.controls['incluye_iva'].value;
		
		if (incluyeIva._checked) {
			this.myForm.controls['iva'].setValue(129);
			this.myForm.controls['graba_iva'].setValue(incluyeIva._checked);
		} else {

			this.myForm.controls['iva'].setValue("");
			this.myForm.controls['graba_iva'].setValue(false);

		}

	}

	activeGrabaIva() {
		let id = this.myForm.controls['iva'].value;
		let valor_iva;
		this.impuestoPorcentajeService.getById(id).subscribe(
			res => {
				valor_iva = (res.porcentaje * 100) / 100;
				if (valor_iva > 0) {
					this.myForm.controls['graba_iva'].setValue(true);
				} else {
					this.myForm.controls['graba_iva'].setValue(false);
				}
			}, err => {
				valor_iva = 0;
			}
		);

	}

	getCuentaContable(codigo) {
		return new Promise((resolve, reject) => {
			this.loading = true;
			this.cuentaContableService.getByCodigo(codigo).subscribe(
				res => {
					let resp = [];
					resp = res;
					resp.forEach(c => {
						if (c.codigo == 1010301) {
							this.cta_ingreso = c.nombre;
							this.cta_ingreso_id = c.id;
						} else {
							this.cta_inventario = c.nombre;
							this.cta_inventario_id = c.id;
						}
					})
					resolve(true);
				},
				err => {
					reject();
				});
		});
	}

	openDialogCuenta(parametroCuenta) {
		this.bsModalRef = this.modalService.show(CuentaContableModalComponent, Object.assign({}, { class: 'modal-xlg' }));
		this.bsModalRef.content.sendCuenta.take(1).subscribe((value) => {
			// this.cta_ingreso = value.nombre;
			// this.cta_ingreso_id = value.id;
			parametroCuenta.cuentacontable = value;
			parametroCuenta.cuenta_contable_id = value.id;
			parametroCuenta.status = 'A';
			// if(parametroCuenta.nombre.trim() == 'Ingresos'.trim()){
			// 	this.producto
			// }
		});
	}

	// openDialogCuentaInventario() {
	// 	this.bsModalRefCuentaInventario = this.modalService.show(CuentaContableModalComponent, Object.assign({}, { class: 'modal-xlg' }));
	// 	this.bsModalRefCuentaInventario.content.sendCuenta.take(1).subscribe((value) => {
	// 		this.cta_inventario = value.nombre;
	// 		this.cta_inventario_id = value.id;
	// 	});
	// }

	limpiarIce() {
		this.impuesto_porcentaje.id = "";
		this.impuesto_porcentaje.descripcion = "";
	}

	get formatDecimal() {
		return this.format_decimal;
	}

	onPrintBarCode() {
		if (!this.myForm.controls['codigo'].value) {
			this.msg.showMessage("error-message", "Falta el código del producto");
			return;
		}
		if (!this.myForm.controls['nombre'].value) {
			this.msg.showMessage("error-message", "Falta el nombre del producto");
			return;
		}
		let params = [];

		params["fecha_emision"] = moment(this.fecha_emision).format("YYYY-MM-DD");
		params["empresa_id"] = this.ss.getData('empresa_id');
		params["usuario_id"] = this.ss.getData('usuario_id');
		this.producto_codigo = this.myForm.controls['codigo'].value;
		this.producto_nombre = this.myForm.controls['nombre'].value;


		if (this.producto_codigo) {
			params["codigo"] = this.producto_codigo;
		}
		Array(this.producto.nombre).splice(0, 10);
		let nombre_1 = this.producto_nombre.substring(0, 15);
		let nombre_2 = this.producto_nombre.substring(15, 40);
		if (this.producto_nombre) {
			params["nombre_1"] = nombre_1;
		}
		if (this.producto_nombre) {
			params["nombre_2"] = nombre_2;
		}


		let qs = [];
		for (let key in params) {
			let str = key + "=" + params[key];
			qs.push(str);
		}

		const initialState = { route: "productoBarCode", qs: "?" + qs.join("&") + "&dbname=" + this.ss.getData('dbname') };
		this.bsModalRef = this.modalService.show(ReporteModalComponent, Object.assign({}, { class: 'modal-xlg', initialState }));
	}

	limpiarCuentaIngreso() {
		this.cta_ingreso = "";
		this.cta_ingreso_id = "";
	}

	limpiarCuentaInventario() {
		this.cta_inventario = "";
		this.cta_inventario_id = "";
	}
}



// WEBPACK FOOTER //
// /var/www/nodejs/nextstore/src/app/forms/producto-frm-add/producto-frm-add.component.ts